import React, { Component } from 'react';
import { cmsGetPromise } from '../CallMSAPI.js';
import ExpandingTable from '../ExpandingReactTable.js';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react';
import { DOMAIN_CODE } from '../LicenceHelpers';
import dayjs from '../dayjs.js';

var _ = require('lodash');

class AccountSubscriptionTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            editEntry: null
        };

        this.fetchData = this.fetchData.bind(this);
        this.getColumns = this.getColumns.bind(this);
        this.mergeEntry = this.mergeEntry.bind(this);
    }

    fetchData(filterValues, searchText, pageSize, page, sortSettings) {
        var self = this;

        var apiParams = {
            accountId: self.props.targetAccount.Id,
            objectType: 'targetsubscriptions',
            State: (self.props.onlyActive ? 'Active' : null),
        };

        if (pageSize) {
            apiParams['pageSize'] = pageSize;
        }
        if (page) {
            apiParams['currentPage'] = page;
        }

        return cmsGetPromise(apiParams);
    }

    mergeEntry(entry) {
        var self = this;
        var tempEntry = _.find(self.props.commercialSubs, { Id: entry.Id });
        if (tempEntry) {
            entry = tempEntry;
        }
        var offer = _.find(self.props.offers, function (o) { return o.Id === entry.OfferId });
        if (offer) {
            entry['_FullOffer'] = offer;
            if (offer.Description) {
                entry.Description = offer.Description;
            }
        }
        return entry;
    }

    getColumns() {
        var self = this;
        var columns = [];

        var mergeEntry = self.mergeEntry;

        columns.push({
            id: 'plan',
            Header: 'Plan',
            sortable: false,
            filterable: false,
            accessor: function (d) {
                var entry = mergeEntry(d);
                return entry.Description ? entry.Description : entry.PlanName;
            }
        });

        columns.push({
            id: 'status',
            Header: 'Status',
            sortable: false,
            filterable: false,
            wrapText: true,
            accessor: function (d) {
                var entry = mergeEntry(d);
                var end = dayjs.utc(entry.EndDate);

                var state = entry.State;
                if (entry.NextOfferCode === null && entry.State === 'Active') {
                    state = <span className="error">Active, expiring {end.fromNow()}</span>;
                }

                var canAction = (self.props.globalCanAction
                    && entry.hasOwnProperty('UnitPrice')
                    && entry.hasOwnProperty('_FullOffer')
                    && entry._FullOffer
                );

                var canCancel = canAction;
                var sfbCheck = (entry.PlanCode === DOMAIN_CODE ? true : false);
                if (self.props.accountServicesLoaded) {
                    if (sfbCheck && self.props.hasActiveSFBEnterpriseService) {
                        canCancel = false;
                    }
                }

                return (
                    <>
                        {state}
                        &nbsp;
                        {canAction && canCancel && entry.State === 'Active'
                            ? <button className="btn btn-xs" title='Delete Subscription' onClick={() => self.props.onCancelSubscription(entry)}>
                                <i className="fa-solid fa-trash"></i>
                            </button>
                            : null}
                    </>
                );
            }
        });

        columns.push({
            id: 'quantity',
            Header: 'Quantity',
            sortable: false,
            filterable: false,
            className: 'text-right',
            accessor: function (d) {
                var entry = mergeEntry(d);
                var quantity = entry.Quantity;
                entry.TempQuantity = (entry.hasOwnProperty('NewQuantity') ? entry.NewQuantity : entry.Quantity);
                if (entry.hasOwnProperty('NewQuantity')) {
                    quantity = (
                        <>
                            <strike>{quantity}</strike>
                            &nbsp;
                            <strong>{entry.NewQuantity}</strong>
                        </>
                    );
                }
                return quantity;
            }
        });

        columns.push({
            id: 'actions',
            Header: '',
            sortable: false,
            filterable: false,
            accessor: function (d) {
                var entry = mergeEntry(d);
                var canAction = (self.props.globalCanAction
                    && entry.hasOwnProperty('UnitPrice')
                    && entry.hasOwnProperty('_FullOffer')
                    && entry._FullOffer
                );

                if (!canAction) {
                    return null;
                }

                return (
                    <>
                        {entry.State === 'Active'
                            ? (
                                <>
                                    <button className="btn btn-xs" title='Edit Subscription' onClick={() => {
                                        entry.TempQuantity = entry.hasOwnProperty('NewQuantity') ? entry.NewQuantity : entry.Quantity;
                                        self.setState({ editEntry: entry });
                                    }}>
                                        <i className="fa-solid fa-pencil"></i>
                                    </button>&nbsp;
                                </>
                            )
                            : null}
                    </>
                );
            }
        });

        columns.push({
            id: 'unitprice',
            Header: 'Unit Price',
            sortable: false,
            filterable: false,
            className: 'text-right',
            accessor: function (d) {
                var entry = mergeEntry(d);
                if (entry.UnitPrice) {
                    return <span>{entry.CurrencyCode} {entry.UnitPrice.toFixed(2)}</span>;
                }
                return null;
            }
        });

        columns.push({
            id: 'total',
            Header: 'Total',
            sortable: false,
            filterable: false,
            className: 'text-right',
            accessor: function (d) {
                var entry = mergeEntry(d);
                if (!entry.UnitPrice) {
                    return null;
                }
                var currencySymbol = entry.CurrencyCode;
                var price = <span>{currencySymbol} {(entry.Quantity * entry.UnitPrice).toFixed(2)}</span>;

                if (entry.hasOwnProperty('NewQuantity')) {
                    price = (
                        <>
                            <strike>{price}</strike>
                            &nbsp;
                            <strong>{currencySymbol} {(entry.NewQuantity * entry.UnitPrice).toFixed(2)}</strong>
                        </>
                    );
                }
                return price;
            }
        });

        return columns;
    }

    render() {
        var self = this;
        var editEntry = self.state.editEntry;

        var quantityChangeDialog = editEntry ? (
            <Dialog
                hidden={false}
                onDismiss={() => self.setState({ editEntry: null })}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Update Quantity',
                }}
                modalProps={{
                    styles: { main: { maxWidth: 450 } },
                }}
            >
                <label><strong>New Quantity</strong>
                    <input className="form-control" type="number" min={editEntry._FullOffer.MinQuantity} max={editEntry._FullOffer.MaxQuantity} defaultValue={editEntry.TempQuantity}
                        onChange={(e) => { editEntry.TempQuantity = e.currentTarget.value; }}
                    />
                </label>

                <DialogFooter>
                    <DefaultButton onClick={() => self.setState({ editEntry: null })} text="Cancel" />
                    <PrimaryButton onClick={() => {
                        self.props.onUpdateSubscriptionQuantity(editEntry);
                        self.setState({ editEntry: null });
                    }} text="Update Quantity" />
                </DialogFooter>
            </Dialog>
        ) : null;

        return (
            <>
                {quantityChangeDialog}
                <ExpandingTable
                    className="order-table"
                    columns={self.getColumns()}
                    update={self.props.lastUpdate}
                    loadingText={"Loading Subscriptions..."}
                    noDataText={"You do not currently have any subscriptions"}
                    showPagination={true}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    defaultPageSize={20}
                    fetchData={self.fetchData}
                    disableSortBy={true}
                    SubComponent={(row) => {
                        var entry = self.mergeEntry(row.original);
                        var formatDate = (val) => val ? dayjs.utc(val).local().format('DD MMM YYYY HH:mm') : '�';
                        return (
                            <div className="p-2">
                                <table className="table table-condensed mb-0">
                                    <tbody>
                                        <tr>
                                            <th>External ID</th>
                                            <td>{entry.ExternalId || '-'}</td>
                                            <th>Offer Code</th>
                                            <td>{entry.OfferCode || '-'}</td>
                                        </tr>
                                        <tr>
                                            <th>Created On</th>
                                            <td>{formatDate(entry.CreatedOn)}</td>
                                            <th>Modified On</th>
                                            <td>{formatDate(entry.ModifiedOn)}</td>
                                        </tr>
                                        <tr>
                                            <th>State Changed On</th>
                                            <td>{formatDate(entry.StateChangedOn)}</td>
                                            <th>End Date</th>
                                            <td>{formatDate(entry.EndDate)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        );
                    }}
                />
            </>
        );
    }
}

export default AccountSubscriptionTable;
